"use client"

import {
  Box,
  TextField,
  Button,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Pagination,
  CircularProgress,
  Alert,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Container,
  InputAdornment,
  Chip,
  Divider,
} from "@mui/material"
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Search as SearchIcon,
  Close as CloseIcon,
  Category as CategoryIcon,
  Refresh as RefreshIcon,
  Language as LanguageIcon,
} from "@mui/icons-material"
import { styled } from "@mui/material/styles"
import type React from "react"
import { useEffect, useState } from "react"
import axios from "axios"
import { requestID, baseURL, config } from "../../../common/utils"
import { IonContent, IonPage } from "@ionic/react"

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
  border: "1px solid rgba(0,0,0,0.06)",
}))

const HeaderCard = styled(Box)(({ theme }) => ({
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  padding: theme.spacing(3),
  borderRadius: "12px 12px 0 0",
}))

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 12,
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  },
}))

const StatsCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  textAlign: "center",
  borderRadius: 8,
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
}))

export const fetchCategories = async (): Promise<string[]> => {
  const payload = { requestID: requestID() }
  const res = await axios.post(`${baseURL}warehouses/getCategories`, payload, config)
  if (res.data.status === "true") {
  console.log(res.data.data )

   // return res.data.data.map((cat: any) => cat.category_name || cat.name)

    return res.data.data.map((cat: any) => ({
  label: cat.category_name || cat.name,
  value: cat.category_id,
}));
  }
  throw new Error(res.data.message || "Failed to fetch categories")
}

const OnlineCategoryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState<any>(null)
  const [openDialog, setOpenDialog] = useState(false)
    const [openDialoge, setOpenDialoge] = useState(false)

  const [category, setCategory] = useState<any[]>([])
  const [loading, setLoading] = useState({
    table: false,
    submit: false,
    delete: false,
  })
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const [formValues, setFormValues] = useState({ id: "", name: "" })
  const [searchTerm, setSearchTerm] = useState("")
  const [page, setPage] = useState(1)
  const rowsPerPage = 8

  const fetchCategory = async () => {
    try {
      setLoading((prev) => ({ ...prev, table: true }))
      const result = await fetchCategories()
      setCategory(result.map((name, index) => ({ id: index.toString(), name })))
    } catch (error) {
      setError("Error fetching online categories")
    } finally {
      setLoading((prev) => ({ ...prev, table: false }))
    }
  }

  const handleOpenDialog = () => setOpenDialog(true)

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setSelectedCategory(null)
    setFormValues({ id: "", name: "" })
    setError(null)
  }

   const handleCloseDialoge = () => {
    setOpenDialoge(false)
    setSelectedCategory(null)
    setFormValues({ id: "", name: "" })
    setError(null)
  }
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmite = async () => {
    const payload = {
      requestID: requestID(),
      ...formValues,
      category_id: selectedCategory?.id,
    }

    try {
      setLoading((prev) => ({ ...prev, submit: true }))
      setError(null)
      const endpoint = `${baseURL}onlinecategorys/editOnlineCategory` 
      console.log({ payload })
      const res = await axios.post(endpoint, payload, config)
console.log({ res })
      if (res.data.status === "true") {
        setSuccess(selectedCategory ? "Online category updated successfully!" : "Online category added successfully!")
        fetchCategory()
        handleCloseDialoge()
      } else {
        setError(res.data.message || "Operation failed")
      }
    } catch (err) {
      setError("Something went wrong")
    } finally {
      setLoading((prev) => ({ ...prev, submit: false }))
    }
  }

   const handleSubmita = async () => {
    console.log('i was here ');
    const payload = {
      requestID: requestID(),
      ...formValues,
      category_id: selectedCategory?.id,
    }

    try {
      setLoading((prev) => ({ ...prev, submit: true }))
      setError(null)
      // const endpoint = selectedCategory ? `${baseURL}onlinecategorys/editOnlineCategory` : `${baseURL}onlinecategorys/addOnlineCategory`
       const endpoint = `${baseURL}onlinecategorys/addOnlineCategory`
      console.log({ payload })
      const res = await axios.post(endpoint, payload, config)
console.log({ res })
      if (res.data.status === "true") {
        setSuccess(selectedCategory ? "Online category updated successfully!" : "Online category added successfully!")
        fetchCategory()
        handleCloseDialog()
      } else {
        setError(res.data.message || "Operation failed")
      }
    } catch (err) {
      setError("Something went wrong")
    } finally {
      setLoading((prev) => ({ ...prev, submit: false }))
    }
  }
  const handleEdit = (category: any) => {
    console.log({ category })
    setSelectedCategory(category.label)
    setFormValues({ id: category.value, name: category.label })
    setOpenDialoge(true)
  }

  const handleDelete = async (category_id: string) => {
    if (!window.confirm("Are you sure you want to delete this online category?")) return

    try {
      setLoading((prev) => ({ ...prev, delete: true }))
      const payload = { requestID: requestID(), storeId: category_id }
      await axios.post(`${baseURL}onlinecategorys/deleteOnlineCategory`, payload, config)
      setSuccess("Online category deleted successfully!")
      fetchCategory()
    } catch (error) {
      setError("Failed to delete online category")
    } finally {
      setLoading((prev) => ({ ...prev, delete: false }))
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        setSuccess(null)
        setError(null)
      }, 4000)
      return () => clearTimeout(timer)
    }
  }, [success, error])

 const filteredCategory = category.filter((cat) =>
  (cat.label || "").toLowerCase().includes((searchTerm || "").toLowerCase())
);

  const paginatedCategory = filteredCategory.slice((page - 1) * rowsPerPage, page * rowsPerPage)

  return (
    <IonPage>
      <IonContent>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          {/* Header */}
          <StyledCard sx={{ mb: 3 }}>
            <HeaderCard>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="600"
                    color="#1e293b"
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <LanguageIcon />
                    Online Category Management
                  </Typography>
                  <Typography variant="body2" color="#64748b" sx={{ mt: 0.5 }}>
                    Organize and manage your online product categories
                  </Typography>
                </Box>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={fetchCategory}
                    disabled={loading.table}
                    sx={{ color: "#64748b", borderColor: "#d1d5db" }}
                  >
                    Refresh
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenDialog}
                    sx={{
                      bgcolor: "#1e293b",
                      "&:hover": { bgcolor: "#334155" },
                      textTransform: "none",
                      px: 3,
                    }}
                  >
                    Add Online Category
                  </Button>
                </Stack>
              </Box>
            </HeaderCard>
          </StyledCard>

          {/* Stats */}
          <Box sx={{ mb: 3 }}>
            <StatsCard>
              <LanguageIcon sx={{ fontSize: 32, mb: 1, color: "#64748b" }} />
              <Typography variant="h4" fontWeight="600" color="#1e293b">
                {category.length}
              </Typography>
              <Typography variant="body2" color="#64748b">
                Total Online Categories
              </Typography>
            </StatsCard>
          </Box>

          {/* Alerts */}
          {success && (
            <Alert
              severity="success"
              sx={{ mb: 3, borderRadius: 2 }}
              action={
                <IconButton size="small" onClick={() => setSuccess(null)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              {success}
            </Alert>
          )}

          {error && (
            <Alert
              severity="error"
              sx={{ mb: 3, borderRadius: 2 }}
              action={
                <IconButton size="small" onClick={() => setError(null)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              {error}
            </Alert>
          )}

          {/* Main Content */}
          <StyledCard>
            <CardContent sx={{ p: 3 }}>
              {/* Search */}
              <TextField
                fullWidth
                placeholder="Search online categories..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value)
                  setPage(1)
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{ mb: 3 }}
              />

              {/* Table */}
              <TableContainer component={Paper} sx={{ borderRadius: 2, border: "1px solid #e2e8f0" }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#f8fafc" }}>
                      <TableCell sx={{ fontWeight: "600", color: "#374151", width: "80px" }}>#</TableCell>
                      <TableCell sx={{ fontWeight: "600", color: "#374151" }}>Online Category Name</TableCell>
                      <TableCell sx={{ fontWeight: "600", color: "#374151", width: "120px" }} align="center">
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading.table ? (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ py: 8 }}>
                          <CircularProgress size={40} />
                          <Typography variant="body2" color="#64748b" sx={{ mt: 2 }}>
                            Loading online categories...
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : paginatedCategory.length > 0 ? (
                      paginatedCategory.map((cat, index) => (
                        
                        <TableRow key={cat.name.value} hover>
                          <TableCell>
                            <Chip
                              label={(page - 1) * rowsPerPage + index + 1}
                              size="small"
                              sx={{ bgcolor: "#f1f5f9", color: "#475569", fontWeight: 500 }}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body1" fontWeight="500" color="#1e293b">
                              {cat.name.label}
                           
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <Tooltip title="Edit Online Category">
                                <IconButton
                                  size="small"
                                  onClick={() => handleEdit(cat.name)}
                                  sx={{ color: "#64748b", "&:hover": { bgcolor: "#f1f5f9" } }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Online Category">
                                <IconButton
                                  size="small"
                                  onClick={() => handleDelete(cat.name.category_id)}
                                  disabled={loading.delete}
                                  sx={{ color: "#ef4444", "&:hover": { bgcolor: "#fef2f2" } }}
                                >
                                  {loading.delete ? <CircularProgress size={16} /> : <DeleteIcon fontSize="small" />}
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ py: 8 }}>
                          <LanguageIcon sx={{ fontSize: 48, color: "#cbd5e1", mb: 2 }} />
                          <Typography variant="h6" color="#64748b" sx={{ mb: 1 }}>
                            {searchTerm ? "No matching online categories found" : "No online categories available"}
                          </Typography>
                          <Typography variant="body2" color="#94a3b8">
                            {searchTerm
                              ? "Try adjusting your search terms"
                              : "Create your first online category to get started"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              {filteredCategory.length > 0 && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                  <Pagination
                    count={Math.ceil(filteredCategory.length / rowsPerPage)}
                    page={page}
                    onChange={(e, value) => setPage(value)}
                    color="primary"
                    shape="rounded"
                    size="large"
                  />
                </Box>
              )}
            </CardContent>
          </StyledCard>

          {/* Dialog */}
          <StyledDialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
            <DialogTitle sx={{ pb: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" fontWeight="600">
                  {selectedCategory ? "Edit Online Category" : "Add New Online Category"}
                </Typography>
                <IconButton onClick={handleCloseDialog} sx={{ color: "#64748b" }}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <TextField
                fullWidth
                label="Online Category Name"
                name="name"
                value={formValues.name}
                onChange={handleInputChange}
                required
                placeholder="Enter online category name..."
                sx={{ mt: 1 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LanguageIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 3 }}>
              <Button onClick={handleCloseDialog} sx={{ color: "#64748b", textTransform: "none" }}>
                Cancel
              </Button>
              <Button
                onClick={handleSubmita}
                variant="contained"
                disabled={loading.submit || !formValues?.name?.trim()}
                startIcon={loading.submit ? <CircularProgress size={16} color="inherit" /> : null}
                sx={{
                  bgcolor: "#1e293b",
                  "&:hover": { bgcolor: "#334155" },
                  textTransform: "none",
                  px: 3,
                }}
              >
                {loading.submit ? "Processing..." : selectedCategory ? "Update Online Category" : "Create Online Category"}
              </Button>
            </DialogActions>
          </StyledDialog>


            {/* Dialog */}
          <StyledDialog open={openDialoge} onClose={handleCloseDialoge} fullWidth maxWidth="sm">
            <DialogTitle sx={{ pb: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" fontWeight="600">
                  {"Edit Online Category" }
                </Typography>
                <IconButton onClick={handleCloseDialoge} sx={{ color: "#64748b" }}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <TextField
                fullWidth
                label="Online Category Name"
                name="name"
                value={formValues.name}
                onChange={handleInputChange}
                required
                placeholder="Enter online category name..."
                sx={{ mt: 1 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LanguageIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 3 }}>
              <Button onClick={handleCloseDialoge} sx={{ color: "#64748b", textTransform: "none" }}>
                Cancel
              </Button>
              <Button
                onClick={handleSubmite}
                variant="contained"
                disabled={loading.submit || !formValues.name?.trim()}
                startIcon={loading.submit ? <CircularProgress size={16} color="inherit" /> : null}
                sx={{
                  bgcolor: "#1e293b",
                  "&:hover": { bgcolor: "#334155" },
                  textTransform: "none",
                  px: 3,
                }}
              >
                {loading.submit ? "Processing..." : selectedCategory ? "Update Online Category" : "Create Online Category"}
              </Button>
            </DialogActions>
          </StyledDialog>
        </Container>
      </IonContent>
    </IonPage>
  )
}

export default OnlineCategoryPage